import { GrayscalePalette } from '@tcl-boron-colors/colors';
import { createUseStyles } from 'react-jss';

const defaultTdPaddingX = 15; // Defined in TCL.
const expanderIconWidthExpanded = 14; // Determined by inspection.
const expanderMargin = 25;
const paddingSum = expanderIconWidthExpanded + defaultTdPaddingX + expanderMargin;
const expandedLeftPadding = `${paddingSum}px !important`;
const tableBorder = `1px solid ${GrayscalePalette[250]}`;

const useCustomStyles = createUseStyles({
  wrapper: {
    position: 'relative',
  },

  table: {
    width: '100%',
    borderLeft: tableBorder,
  },
  tr: {
    '$table:not($clickableCells) &, $table &$trExpanded': {
      cursor: 'default',
      background: 'transparent',
    },
  },
  trExpanded: {
    borderRight: tableBorder,
  },
  thContent: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'row',
  },
  tdExpanded: {
    paddingLeft: expandedLeftPadding,

    '$subtableParent &': {
      padding: '0 !important',
    },
  },

  filter: {
    paddingTop: '8px !important',
  },
  filterPlaceholder: {
    width: 0,
  },

  expander: {
    marginRight: expanderMargin,
  },
  noContentWrapper: {
    padding: 20,
    width: '100%',
  },
  sortIcon: {
    marginLeft: 5,
    display: 'flex',
  },
  spinnerHeight: {
    minHeight: 100,
  },

  // Required for typing
  clickableCells: {},
  subtableParent: {},
  th: {},
});

export default useCustomStyles;

export type FilterableDataTableClassKeys = keyof ReturnType<typeof useCustomStyles>;
